export default {
  subscriptions: {},
  lastId: -1,
  init() {
    window.smr_eventbus = this;
  },
  on(eventName, callback) {
    const id = (this.lastId += 1);

    if (!this.subscriptions[eventName]) this.subscriptions[eventName] = {};

    this.subscriptions[eventName][id] = callback;

    return {
      off: () => {
        delete this.subscriptions[eventName][id];
        if (Object.keys(this.subscriptions[eventName]).length === 0)
          delete this.subscriptions[eventName];
      },
    };
  },

  emit(eventName, payload) {
    if (!this.subscriptions[eventName]) return;

    Object.keys(this.subscriptions[eventName]).forEach((key) =>
      this.subscriptions[eventName][key](payload)
    );
  },
};
